import { endpoints } from "../ApiEndPoints/apiEndPoints";
import { getRequestApiMasterData } from "../Redux/Hooks/useGetApi";
import { consolelog } from "../helpers/consolelog";

export const pageCountValidation = (totalCount: number | undefined, queryPageSize: number | undefined) => {
  if (totalCount === undefined || queryPageSize === undefined) {
    return 0;
  } else {
    return Math.ceil(totalCount / queryPageSize)
  }
}
export const loadFamilyGroupOptions = (value: any, productType?: string) => {
  const params = {
    service: endpoints.getFamilyGroupMasterData(),
    skip: 0,
    take: 0,
    isEnabled: true,
    //filter: `(contains(tolower(FamilyGroup),'${value?.toLowerCase()}'))`,
    filter: `contains(tolower(FamilyGroup),'${value?.toLowerCase()}')and ProductType eq '${productType}'`,
    key: ``,
    onError(error: any) {
      consolelog(error)
    },
    onSuccess(result: any) {
      consolelog(result)
    },
  }
  return getRequestApiMasterData(params).then((response: any) =>
    response?.data?.value?.map((item: any) => (
      {
        label: `${item?.FamilyGroup?.toString()}`,
        value: { desc: item?.FamilyGroup?.toString() },
      })
    ))
}

export const getFamilyGroupManagement = async (familyGroup: string, productType: string) => {
  const params = {
    service: endpoints.getFamilyGroupMasterData(),
    skip: 0,
    take: 0,
    isEnabled: true,
    filter: encodeURIComponent(`tolower(FamilyGroup) eq '${familyGroup?.toLowerCase()}' and ProductType eq ${productType == null ? null : `'${productType}'`} `),
    key: ``,
    onError(error: any) {
      consolelog(error)
    },
    onSuccess(result: any) {
      consolelog(result)
    },
  }
  return getRequestApiMasterData(params).then((response: any) =>
    response?.data?.value?.map((item: any) => (
      {
        familyGroup: `${item?.FamilyGroup?.toString()}`,
        productType: `${item?.ProductType?.toString()}`
      })
    ))
}